import {LogoContainerCasino888WsopBox} from "./logo-container.casino888Wsop.box";

export const LogoContainerCasino888Box = LogoContainerCasino888WsopBox;